module.exports = __webpack_public_path__ + "img/logo.694f186b.png";